import { CarBodiesType } from '@entities/Auto';
import { compare } from '@sharedHelpers/compare';

export const sortCarBodies = (a: CarBodiesType, b: CarBodiesType) => {
  return compare(Number(b.yearF), Number(a.yearF)) || compare(Number(b.yearB), Number(a.yearB));
};
